import Tutorial from './tutorial.vue'
export default Tutorial
